<section class="content">
  <div class="content-block">
    <div class="m-4"></div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-title">
                  <div>
                    <h2>
                      {{'Help' | translate}}
                    </h2>
                  </div>
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">

                <li class="tbl-header-btn">
                                    <div class="m-l-10" matTooltip="{{'COMMON.TOOL_TIP.BACK' |
                                    translate}}">
                    <button aria-label="close" mat-mini-fab color="warn" (click)="back()">
                      <mat-icon class="col-white">close</mat-icon>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="body">
            <div class="row">
              <div class="col-6">
                <div class="card">
                  <div class="left">
                    <ul class="header-buttons-left ms-0">
                      <li style="padding: 10px; size: 90px;">
                        <h6>{{'Contact Support' | translate}}</h6>
                      </li>
                    </ul>
                  </div>
                  <form class="m-3" [formGroup]="contact_support_form">
                    <div>
                      <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>{{'Email' | translate}}</mat-label>
                        <input matInput formControlName="help_email">
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>{{'Contact No' | translate}}</mat-label>
                        <input required formControlName="help_phone" matInput
                          mask="(000) 000 0000" />
                      </mat-form-field>
                    </div>


                    <div>
                      <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>{{'Subject' | translate}}</mat-label>
                        <input matInput formControlName="help_subject">

                      </mat-form-field>
                    </div>

                    <div class="row form-old">
                      <div class="mt-2">
                        <mat-form-field class="example-full-width" appearance="outline">
                          <mat-label>{{'Message' | translate}}</mat-label>
                          <textarea matInput formControlName="help_message"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="mt-2" align="center">
                      <button mat-raised-button color="primary"
                        (click)="sendButtonAction()">{{'Send' |
                        translate
                      }}</button>

                    </div>
                  </form>
                </div>
              </div>

              <div class="col-6">
                <div class="card">
                  <div class="left">
                    <ul class="header-buttons-left ms-0">
                      <li style="padding: 10px; size: 90px;">
                        <h6>
                          {{'Help' | translate}}
                        </h6>
                      </li>
                    </ul>
                  </div>

                  <div class="row">
                    @for (setting of helpDetailCards; track setting) {
                      <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                        >
                        <div class="card card-border top-sell p-2"
                          (click)="openHelpFile(setting.help_file_url)">
                          <div class="d-flex align-items-center">
                            <i [ngClass]="setting.icon" class="my-auto"></i>
                            <div class="product-title my-auto">
                              {{ setting.title }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>



                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>